<template>
    <div>
      <div class="at-message-qoute">
        <div class="at-message-qoute_content" :class="{
          'at-reply-video':messageProps.attachmentsData.attachmentType == 'video',
          'at-reply-location':Number(messageProps.messageType) == 2,
          'at-reply-voice':Number(messageProps.messageType) == 3,
          'at-reply-file':messageProps.attachmentsData.attachmentType == 'file',
          'at-reply-images':messageProps.attachmentsData.attachmentType == 'images',
        }">
        <!-- For media message -->
          <template v-if=" Number(messageProps.messageType) == 1"> 
            <template v-if="messageProps.attachmentsData.attachmentType == 'images'">
              <ul class="at-message_imgs at-messagequote">
                <li v-for="(image, index) in computedReplyMessage" :key="index">
                    <figure>
                        <img :src="image.thumbnail" :alt="image.fileName" class="mCS_img_loaded">
                        <span v-if="messageProps.attachmentsData.attachments.length > showImages && index == (showImages-1)"> +{{ messageProps.attachmentsData.attachments.length - showImages}}</span>
                    </figure>
                </li>
              </ul>
            </template>
            <template v-if="messageProps.attachmentsData.attachmentType == 'video'">
              <video-player  class="video-player-box"
                ref="videoPlayer"
                :options="playerOption()"
                :playsinline="true"
                customEventName="customstatechangedeventname" >
              </video-player>
            </template>
            <template v-if="messageProps.attachmentsData.attachmentType == 'audio'">
              <div class="at-sendfile">
                <i class="guppy-music"></i>
                <span>{{messageProps.attachmentsData.attachments[0].fileName}}<em>{{messageProps.attachmentsData.attachments[0].fileSize}}</em></span>
              </div>
            </template>
            <template v-if="messageProps.attachmentsData.attachmentType == 'file'">
              <div class="at-sendfile">
                  <i class="guppy-file"></i>
                  <span>{{messageProps.attachmentsData.attachments[0].fileName}}<em>{{messageProps.attachmentsData.attachments[0].fileSize}}</em></span>
              </div>
            </template>
          </template>
          <template v-else-if=" Number(messageProps.messageType) == 3">
            <mini-audio 
              muted="false" 
              :audioSource="messageProps.attachmentsData.attachments[0].file">
            </mini-audio>
          </template>
          <template v-else-if="Number(messageProps.messageType) == 2">
            <l-map style="height: 200px; width:400px; border-radius: 3px;" :zoom="zoom" :center="getMapLocation(messageProps.message)">
              <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
              <l-marker :lat-lng="getMapLocation(messageProps.message)"></l-marker>
            </l-map>
          </template>
          <span v-else>{{messageProps.message}}</span> 
        </div>
        <slot name="message_actions"></slot>
      </div>
      <slot></slot>
    </div> 
</template>

<script>
import { GUPPYCHAT_CONSTANTS } from "../../../resources/constants";
export default {
    name : "GuppyChatQuoteMessageList",
    props:['messageProps'],
    data(){
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 15,
            center: [],
            markerLatLng: []
        }
    },
    computed:{
        computedReplyMessage() {
            if(this.messageProps.attachmentsData.attachmentType == 'images'){
              let showImages = 3;
              if( this.$store.state.isMessangerChat ) {
                showImages = 4
              } 
                return this.messageProps.attachmentsData.attachments.filter((item, index) => index < showImages);
            } else {
                return null;
            }
        },
        showImages(){
          let showImages = 3;
          if( this.$store.state.isMessangerChat ) {
            showImages = 4
          }
          return showImages;
        },
    },
    methods:{
        playerOption(){
            let data = this.messageProps;
            let videoData = data.attachmentsData.attachments[0]
            let playerOptions = {
                height: '200',
                width:'400',
                autoplay: false,
                // videojs options
                muted: true,
                language: 'en',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                type: "video/"+videoData.fileType,
                src: videoData.file
                }],
                poster: GUPPYCHAT_CONSTANTS.VIDEO_THUMBNAIL,
            }
            return playerOptions
            
        },
        getMapLocation(data){
            return [data.latitude, data.longitude];
        }
    }
}
</script>